// extracted by mini-css-extract-plugin
export default {"table":"RecommendationList_table__GEQiI","add-container":"RecommendationList_add-container__NEWEA","add":"RecommendationList_add__t+OuQ"};